//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../GeometricUtilities/GeometricUtilities.CurveOptions.js";
import "../no/Section.js";
import "../no/SelectCurveList.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AddFillets",1,0],[1,"AngularThreshold",0,"Expression",0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[1,"CurveOptions",0,"GeometricUtilities.CurveOptions",0],[1,"Curves",0,"Section",0],[1,"DistanceThreshold",0,"Expression",0],[1,"FixedCurves",0,"SelectCurveList",0],[0,"LevelType",1,0],[0,"MergeType",1,0],[1,"Radius",0,"Expression",0],[1,"SupportFaces",0,"ScCollector",0],[1,"Tolerance",0,"Expression",0],[0,"Type",1,0]],[[[],"UpdateOnExpressionChange",{},0,0]],[]];
SPLM.Features.SmoothCurveStringBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SmoothCurveStringBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SmoothCurveStringBuilder.Types = Object.freeze({
    "FreeCurves" : "FreeCurves", "CurvesOnSurfaces" : "CurvesOnSurfaces"});

SPLM.Features.SmoothCurveStringBuilder.LevelTypes = Object.freeze({
    "G0" : "G0", "G1" : "G1", "G2" : "G2"});

SPLM.Features.SmoothCurveStringBuilder.MergeTypes = Object.freeze({
    "None" : "None", "SameTypes" : "SameTypes", "AllCurves" : "AllCurves"});

export default SPLM;